module.exports = __webpack_public_path__ + "img/helperinfo-portrait.741b918b.png";